import { createFileRoute } from '@tanstack/react-router';
import { TopologyPage } from '@/pages/TopologyPage';

export const Route = createFileRoute('/topology')({
  component: TopologyPage,
});
